module.exports = __webpack_public_path__ + "static/media/main_3.017aad45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/main_3.jpg
// module id = 892
// module chunks = 0